function HanadleProductSlier()
{
    var productMediaMain = document.querySelector('.product-media-main');
    if (productMediaMain !== null && productMediaMain !== undefined) {
        if (window.innerWidth <= 768 && !$(".product-media-main").hasClass("slick-initialized")) {
            $(".product-media-main").slick({ slidesToShow: 1, infinite: false, centerMode: false, centerPadding: '20px' });
        } else if (window.innerWidth > 768 && $(".product-media-main").hasClass("slick-initialized")) {
            $( ".product-media-main" ).slick('unslick');
        }
    }
}

function HandleProductThumbnails()
{
    var productThumbnails = document.querySelectorAll( ".product-media-thumbnail" );
    productThumbnails.forEach( function( productThumbnail )
    {
        productThumbnail.addEventListener( "click", HandleProductThumbnailClick );
    } );
}

function HandleProductThumbnailClick( e )
{
    var element             = e.currentTarget;
    var thumbnailInner      = element.querySelector( ".product-media-wrapper" );
    var thumbnailMediaID    = thumbnailInner.getAttribute( "data-media-id" );

    var mainProductMedias    = document.querySelectorAll( ".product-media-main .product-media-main-item" );
    mainProductMedias.forEach( function( mainProductMedia )
    {
        var mainProductMediaID = mainProductMedia.getAttribute( "data-media-id" );
        mainProductMedia.classList.remove( "is-active" );

        if( mainProductMediaID == thumbnailMediaID )
        {
            mainProductMedia.classList.add( "is-active" );
        }
    } );
}

window.addEventListener( "DOMContentLoaded", function()
{
    HandleProductThumbnails();
    HanadleProductSlier();
} );
window.addEventListener( "resize", HanadleProductSlier );